import { render, staticRenderFns } from "./service-details-modal.vue?vue&type=template&id=6e86b673&scoped=true"
import script from "./service-details-modal.vue?vue&type=script&lang=js"
export * from "./service-details-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e86b673",
  null
  
)

export default component.exports